<template>
  <div v-if="tabs" class="tab-panel-container py-2 px-3">
    <!-- <DxTabPanel height="70%">
      <DxItem v-for="(tab, index) in tabs" :key="index" :title="tab.title" class="tab-item" :disabled="tab.disabled">
        <component :is="tab.component" v-bind="tab.props"></component>
      </DxItem>
    </DxTabPanel> -->
    <DelegacionesGrid :idEmpresaInmobiliaria="props.idEmpresaInmobiliaria"></DelegacionesGrid>
  </div>
</template>

<script setup lang="ts">
import { useIntl } from '@services/i18n';
import DxTabPanel, { DxItem } from 'devextreme-vue/tab-panel';
import DelegacionesGrid from '@/components/delegaciones/DelegacionesInmobiliariasGrid.vue';

const props = defineProps({
  idEmpresaInmobiliaria: { type: String, required: true }
});

const intl = useIntl();
const tabs = [
  { title: intl.i18n.t('delegaciones.titulo'), component: DelegacionesGrid, props: { idEmpresaInmobiliaria: props.idEmpresaInmobiliaria }, disabled: false }
];

</script>

<style lang="scss" scoped>


.tab-panel-container {
  background-color: var(--background-surface-default);
  border: 1px solid var(--border-default-default);
  border-radius: 5px;
}

.dx-tabpanel-container {
  padding-top: 15px;
}
</style>